import BreadCrumb from "../screens/Common/BreadCrumb";
import React from "react";

import LayoutContainer from "../screens/layout/admin-dashboard";
import AutoNumberingProfile from "../screens/masters/autoNumbering/autoNumberingProfile";

const breadCrumbData = [
  { link: "/masters-list", name: "Masters" },
  { link: "/auto-numbering-list", name: "Auto Numbering" },
  { link: "/auto-numbering-details", name: "Auto Numbering Details" }
];

const Home = () => (
  <>
    <LayoutContainer>
      <BreadCrumb data={breadCrumbData} />
      <AutoNumberingProfile />
    </LayoutContainer>
  </>
);

export default Home;
